import React from 'react';
// import { useSelector } from 'react-redux';
import { Bounce, ToastContainer } from 'react-toastify';
import './assets/styles/auth.css';
import './assets/styles/button.css';
import 'react-toastify/dist/ReactToastify.css';
// import Loader from './components/Loader';
import Routes from './routes';

function App() {
    // const { isLoading } = useSelector((state) => state.app);
    // useEffect(() => {
    //     if ('serviceWorker' in navigator) {
    //         navigator.serviceWorker
    //             .register('/firebase-messaging-sw.js')
    //             .then((registration) => {
    //                 console.log('Service Worker registered with scope:', registration.scope);
    //             })
    //             .catch((err) => {
    //                 console.error('Service Worker registration failed:', err);
    //             });
    //     }
    // }, []);

    return (
        <>
            {/* {isLoading && <Loader />} */}
            <Routes />
            <ToastContainer
                position='top-center'
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop
                closeOnClick
                pauseOnHover
                theme='dark'
                transition={Bounce}
                toastStyle={{
                    backgroundColor: 'rgba(15, 23, 42, 0.9)', // Deep Slate with transparency
                    backdropFilter: 'blur(12px)',
                    borderRadius: '20px',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2)',
                    fontFamily: '\'Inter\', sans-serif',
                    padding: '12px 20px',
                    margin: '10px'
                }}
                bodyStyle={{
                    fontSize: '14px',
                    fontWeight: '600',
                    letterSpacing: '-0.2px',
                    color: '#F8FAFC'
                }}
            />
        </>
    );
}

export default App;
